import hexagonPath from "./hexagonPath.js";
import hollowknight from "./hollowknight.js";
import hyperspace from "./hyperspace.js";
export default {
    hexagonPath,
    hollowknight,
    hyperspace,
};
